import { ReactNode } from "react";

interface SettingsMetaContentProps {
  children: ReactNode;
  className?: string;
}

export function SettingsMetaContent({ children, className = "space-y-6" }: SettingsMetaContentProps) {
  return <div className={`max-w-2xl mx-auto w-full ${className}`}>{children}</div>;
}

interface SettingsMetaPageProps {
  children: ReactNode;
  className?: string;
}

export function SettingsMetaPage({ children, className = "space-y-2" }: SettingsMetaPageProps) {
  return (
    <div className="p-4 w-full">
      <SettingsMetaContent className={className}>{children}</SettingsMetaContent>
    </div>
  );
}
